module.exports = __webpack_public_path__ + "static/media/icon_general_error.f07eb740.png";